import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { ProformViewStates } from '../../../dtos/proforms.dto';
import {
  ProFormContext,
  ProFormsSubmissionAPIResponse,
} from '../../../types/responses/proforms.responses';
import { ModalComponent } from '../modal/modal.component';

@Component({
  selector: 'app-proform-survey-modal',
  standalone: false,
  templateUrl: './proform-survey-modal.component.html',
  styleUrl: './proform-survey-modal.component.scss',
})
export class ProformSurveyModalComponent {
  @Input() formId: number;

  @Input() sessionId: number;

  @ViewChild('modal') modal: ModalComponent;

  @Output() readonly formSubmitted =
    new EventEmitter<ProFormsSubmissionAPIResponse>();

  contextType = ProFormContext.PD_SESSION;

  viewStates = ProformViewStates;

  openModal() {
    this.modal.open();
  }

  closeModal() {
    this.modal.close();
  }

  onFormSubmit(submission: ProFormsSubmissionAPIResponse) {
    this.formSubmitted.emit(submission);
  }
}
